import React, { forwardRef } from 'react';
import { Platform, Pressable } from 'react-native';

// Keep the existing in-app action for ordinary presses, while exposing a real
// destination for crawlers, copy-link and modified/new-tab browser clicks.
const CatalogLink = forwardRef(function CatalogLink({ href, onPress, component: Component = Pressable, style, ...props }, ref) {
  const webLink = Platform.OS === 'web' && href;
  return <Component {...props} ref={ref}
    style={webLink ? (typeof style === 'function'
      ? state => [{ textDecorationLine: 'none' }, style(state)]
      : [{ textDecorationLine: 'none' }, style]) : style}
    {...(webLink ? { href, accessibilityRole: 'link' } : {})}
    onPress={event => {
      if (webLink && (event?.metaKey || event?.ctrlKey || event?.shiftKey || event?.altKey
        || (event?.button != null && event.button !== 0))) return;
      if (webLink && onPress) event?.preventDefault?.();
      onPress?.(event);
    }} />;
});

export default CatalogLink;
